import React, { useState, useEffect } from "react";
import "../styles/vehicledetails.css";
import { fetchVehicleDetails } from "../services/vehicleDetailService";
import { formatAmount } from "../utils/formatAmount";

function formatDate(date) {
  if (!date) return "-";
  const d = new Date(date);
  return d.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric"
  });
}

function validate(value) {
  if (
    value === null ||
    value === undefined ||
    value === "" ||
    value === "null" ||
    value === "undefined"
  ) {
    return null;
  }
  return value;
}

function amountvalidate(value) {
  if (
    value === 0 ||
    value === null ||
    value === undefined ||
    value === "" ||
    value === "null" ||
    value === "undefined"
  ) {
    return "-";
  }
  return value;
}

function joinValues(...values) {
  return values.filter(v => validate(v)).join(" ");
}

function formatManufactured(year, month) {
  const y = validate(year);
  const m = validate(month);

  if (y && m) return `${y} / ${m}`;
  if (y) return `${y}`;
  if (m) return `${m}`;

  return null;
}

function VehicleDetails({ vehicle }) {


  const [selectedIndex, setSelectedIndex] = useState(null);

const openImage = (index) => {
  setSelectedIndex(index);
};

const closeModal = () => {
  setSelectedIndex(null);
};

const prevImage = () => {
  setSelectedIndex((prev) =>
    prev === 0
      ? v.photo_list.length - 1
      : prev - 1
  );
};

const nextImage = () => {
  setSelectedIndex((prev) =>
    prev === v.photo_list.length - 1
      ? 0
      : prev + 1
  );
};

  const [details, setDetails] = useState(null);
  const [showOtherPurchase, setShowOtherPurchase] = useState(false);

  useEffect(() => {
    if (!vehicle) return;

    const loadDetails = async () => {
      try {
        const apiData = await fetchVehicleDetails(
          vehicle.invoice_id,
          vehicle.detail_id
        );

        setDetails({ ...vehicle, ...apiData });

      } catch (error) {
        console.error("Vehicle detail API error:", error);
      }
    };

    loadDetails();

  }, [vehicle]);

  if (!vehicle) {
    return <div className="p-4 text-muted">Select a vehicle</div>;
  }

  if (!details) {
    return <div className="p-4 text-muted">Loading...</div>;
  }

  const v = details;

  return (
    <div className="container-fluid">

      {/* TITLE */}
      <h4 className="fw-bold mb-3 text-primary">
        {joinValues(v.vehicle_make, "-", v.vehicle_model)}
        {validate(v.vehicle_color) && ` (${v.vehicle_color})`}
      </h4>

      {/* ================= BASIC ================= */}
      <div className="card mb-3 shadow-sm">
        <div className="card-header fw-semibold">Basic Information</div>
        <div className="card-body">
          <div className="row g-3">

            <div className="col-md-3">
              <label className="text-muted small">Invoice No</label>
              <div>{v.invoice_no}</div>
            </div>

            {/* <div className="col-md-3">
              <label className="text-muted small">Stock ID</label>
              <div>{v.stock_id}</div>
            </div> */}

            <div className="col-md-3">
              <label className="text-muted small">Status</label>
              <div>
                <span className={`badge bg-${v.status === "Shipped" ? "success" : "warning"}`}>
                  {v.status}
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* ================= VEHICLE ================= */}
      <div className="card mb-3 shadow-sm">
        <div className="card-header fw-semibold">Vehicle Information</div>
        <div className="card-body">
          <div className="row g-3">

            <div className="col-md-3">
              <label className="text-muted small">Make</label>
              <div>{v.vehicle_make}</div>
            </div>

            <div className="col-md-3">
              <label className="text-muted small">Model</label>
              <div>{v.vehicle_model}</div>
            </div>

            <div className="col-md-3">
              <label className="text-muted small">Color</label>
              <div>{v.vehicle_color}</div>
            </div>

            <div className="col-md-3">
              <label className="text-muted small">Chassis No</label>
              <div>{v.chassis_no}</div>
            </div>

            <div className="col-md-3">
              <label className="text-muted small">Engine Capacity</label>
              <div>{v.engine_capacity} CC</div>
            </div>

            <div className="col-md-3">
              <label className="text-muted small">HS Code</label>
              <div>{v.hs_code}</div>
            </div>

            {formatManufactured(v.manufactured_year, v.manufactured_month) && (
              <div className="col-md-3">
                <label className="text-muted small">Manufactured</label>
                <div>
                  {formatManufactured(v.manufactured_year, v.manufactured_month)}
                </div>
              </div>
            )}

          </div>
        </div>
      </div>

      {/* ================= COST ================= */}
      <div className="card mb-3 shadow-sm">
        <div className="card-header fw-semibold">Cost Information</div>
        <div className="card-body">
          <div className="row g-3">

            <div className="col-md-3">
              <label className="text-muted small">Purchase Price</label>
              <div>{amountvalidate(v.purchase_price)}</div>
            </div>

            <div className="col-md-3">
              <label className="text-muted small">Proforma Invoice</label>
              <div>{amountvalidate(v.proforma_invoice_amount)}</div>
            </div>

            <div className="col-md-3">
              <label className="text-muted small">Balance</label>
              <div>{amountvalidate(v.purchase_price_balance)}</div>
            </div>

            <div className="col-md-3">
              <label className="text-muted small">
                Other Purchase
                <span
                  style={{ cursor: "pointer", marginLeft: "6px" }}
                  onClick={() => setShowOtherPurchase(true)}
                >
                  ⓘ
                </span>
              </label>
              <div>{amountvalidate(v.other_purchase_price)}</div>
            </div>

            <div className="col-md-3">
              <label className="text-muted small">Balance to Pay</label>
              <div>{amountvalidate(v.balance_amount)}</div>
            </div>

          </div>
        </div>
      </div>

      {/* ================= SHIPPING ================= */}
      <div className="card mb-3 shadow-sm">
        <div className="card-header fw-semibold">Shipping</div>
        <div className="card-body">
          <div className="row g-3">

            {!v.actual_ship_date && (
              <div className="col-md-3">
                <label className="text-muted small">Estimated Ship</label>
                <div>{formatDate(v.estimated_ship_date)}</div>
              </div>
            )}

            {v.actual_ship_date && (
              <div className="col-md-3">
                <label className="text-muted small">Actual Ship</label>
                <div>{formatDate(v.actual_ship_date)}</div>
              </div>
            )}

            <div className="col-md-3">
              <label className="text-muted small">Docs Sent JP</label>
              <div>{formatDate(v.documents_sent_date_jp)}</div>
            </div>

            <div className="col-md-3">
              <label className="text-muted small">Docs Sent LK</label>
              <div>{formatDate(v.documents_sent_date_lk)}</div>
            </div>

          </div>
        </div>
      </div>

    {/* ================= PHOTOS ================= */}
<div className="card mb-3 shadow-sm">
  <div className="card-header fw-semibold">
    Vehicle Photos
  </div>

  <div className="card-body photo-grid">

    {v.photo_list?.map((photo, index) => {

      const imagePath =
        photo.url.split(":8080/")[1];

      const imageUrl =
        `/vehicle-images/${imagePath}`;

      return (
        <img
          key={index}
          src={imageUrl}
          alt="vehicle"
          loading="lazy"
          decoding="async"
          onClick={() => openImage(index)}
          style={{
            width: "180px",
            aspectRatio: "4 / 3",
            objectFit: "cover",
            borderRadius: "6px",
            display: "block",
            cursor: "pointer"
          }}
          onError={(e) => {
            e.target.src = "/No_Image_Available.jpeg";
          }}
        />
      );
    })}

  </div>
</div>

{/* ================= IMAGE MODAL ================= */}
{selectedIndex !== null && (

  <div
    onClick={closeModal}
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.9)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999
    }}
  >

    {/* LEFT BUTTON */}
    <button
      onClick={(e) => {
        e.stopPropagation();
        prevImage();
      }}
      style={{
        position: "absolute",
        left: "20px",
        fontSize: "40px",
        color: "#fff",
        background: "transparent",
        border: "none",
        cursor: "pointer"
      }}
    >
      ❮
    </button>

    {/* IMAGE */}
    <img
      src={`/vehicle-images/${
        v.photo_list[selectedIndex]
          .url
          .split(":8080/")[1]
      }`}
      alt="preview"
      style={{
        maxWidth: "90%",
        maxHeight: "90%",
        objectFit: "contain",
        borderRadius: "8px"
      }}
      onClick={(e) => e.stopPropagation()}
    />

    {/* RIGHT BUTTON */}
    <button
      onClick={(e) => {
        e.stopPropagation();
        nextImage();
      }}
      style={{
        position: "absolute",
        right: "20px",
        fontSize: "40px",
        color: "#fff",
        background: "transparent",
        border: "none",
        cursor: "pointer"
      }}
    >
      ❯
    </button>

    {/* CLOSE BUTTON */}
    <button
      onClick={closeModal}
      style={{
        position: "absolute",
        top: "20px",
        right: "20px",
        fontSize: "30px",
        color: "#fff",
        background: "transparent",
        border: "none",
        cursor: "pointer"
      }}
    >
      ✕
    </button>

  </div>
)}

{/* ================= ATTACHMENTS ================= */}
<div className="card mb-3 shadow-sm">
  <div className="card-header fw-semibold">
    Vehicle Attachments
  </div>

  <div className="card-body d-flex flex-wrap gap-3">

    {v.attachment_list?.length > 0 ? (
      v.attachment_list.map((file, index) => {

        const imagePath = file.url.split(":8080/")[1];
        const imageUrl = `/vehicle-images/${imagePath}`;

        return (
          <img
            key={index}
            src={imageUrl}
            alt={`attachment-${index}`}
            style={{
              width: "180px",
              height: "120px",
              objectFit: "cover",
              borderRadius: "6px",
              border: "1px solid #ddd",
              cursor: "pointer"
            }}
            onError={(e) => {
              e.target.src = "/No_Image_Available.jpeg";
            }}
            onClick={() => window.open(imageUrl, "_blank")}
          />
        );
      })
    ) : (
      <p className="text-muted mb-0">No Images Available</p>
    )}

  </div>
</div>


{/* ================= DOCUMENTS ================= */}
<div className="card mb-3 shadow-sm">
  <div className="card-header fw-semibold">
    Vehicle Documents
  </div>

  <div className="card-body d-flex flex-wrap gap-3">

    {v.document_list?.length > 0 ? (
      v.document_list.map((file, index) => {

        const fileUrl = file.url.replace("https://", "http://");

        const fileName = decodeURIComponent(
          fileUrl.split("/").pop()
        );

        return (
          <div
            key={index}
            style={{
              width: "220px",
              border: "1px solid #ddd",
              borderRadius: "8px",
              padding: "12px",
              background: "#f8f9fa",
              display: "flex",
              alignItems: "center",
              gap: "10px"
            }}
          >
            <img
              src="/pdf-icon.png"
              alt="pdf"
              style={{
                width: "40px",
                height: "40px",
                objectFit: "contain"
              }}
            />

            <div style={{ flex: 1 }}>
              <div
                style={{
                  fontSize: "13px",
                  fontWeight: "500",
                  wordBreak: "break-word",
                  marginBottom: "6px"
                }}
              >
                {fileName}
              </div>

              <a
                href={fileUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-sm btn-primary"
              >
                Open PDF
              </a>
            </div>
          </div>
        );
      })
    ) : (
      <p className="text-muted mb-0">No Documents Available</p>
    )}

  </div>
</div>
  

      {/* ================= MODAL ================= */}
      {showOtherPurchase && (
        <div className="pr-overlay" onClick={() => setShowOtherPurchase(false)}>
          <div className="pr-modal" onClick={(e) => e.stopPropagation()}>

            <div className="pr-header">
              <h5>Other Purchase Details</h5>
              <button className="btn-close" onClick={() => setShowOtherPurchase(false)}></button>
            </div>

            <div className="pr-body">

              {v.other_purchase_list?.length > 0 ? (
                <table className="table table-bordered">
                  <thead className="table-light">
                    <tr>
                      <th>Remarks</th>
                      <th className="text-end">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {v.other_purchase_list.map((item, i) => (
                      <tr key={i}>
                        <td>{item.remarks}</td>
                        <td className="text-end">
                          {formatAmount(item.amount)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p>No data available</p>
              )}

            </div>

          </div>
        </div>
      )}

    </div>
  );
}

export default VehicleDetails;